
import React from 'react';
import SVGComponent from '../SVG/SVGComponent';
import { SVG_ICONS } from '../../constants';

const InfoMessage = (props) => (
  <div className="modal modal--open">
    <div className="dialog open">
      <div className="dialog__heading">
        <span className="dialog__title">{props.modalData.heading}</span>
        <SVGComponent
          onClick={props.cancel}
          className="icon-xxs  dialog__close"
          src={`${SVG_ICONS.utility}#close`}
        />
      </div>
      <div className="dialog__content text-center">
        <div className="dialog__info">
          {props.modalData.msg}
        </div>
      </div>
      <div className="dialog__btn-wrap">

        <button
          id="yes_ConfirmationModal"
          type="button"
          className="btn btn-primary m-l-10"
          onClick={props.cancel}
        >
          Ok
        </button>
      </div>
    </div>
  </div>
);

export default InfoMessage;
